import React from "react";
import {Col, Row} from "reactstrap";
import PickupTypes from "../../../Models/PickupTypes";
import houseLogo from "../../../Assets/Images/house.png";
import truckLogo from "../../../Assets/Images/truck.png";
import packageLogo from "../../../Assets/Images/package.png";
import {getProgressLineStatus} from "../../../Utils/Utils";
import Shipment from "../../../Models/Shipment";
import City from "../../../Models/City";
import Branch from "../../../Models/Branch";

type Props = {
  shipment: Shipment;
}

const ProgressShipmentComponent: React.FC<Props> = ({shipment}) => {

  const getCityFromBranch = (branch:Branch) => {
    return branch ?  (branch.city as City)?.name : '' ;
  };

  return (
    <div className="d-none d-sm-block justify-content-between">

      <Row className="text-center">
        <Col> <img src={houseLogo} width="33%" alt=""/></Col>
        <Col> <img src={packageLogo} width="32%" alt=""/></Col>
        <Col> <img src={truckLogo} width="45%" alt=""/></Col>
        <Col> <img src={packageLogo} width="32%" alt=""/></Col>
        <Col> <img src={truckLogo} width="45%" alt=""/></Col>
        <Col> <img src={houseLogo} width="33%" alt=""/></Col>
      </Row>

      <svg version="1.1" id="line_2"
           x="0px" y="0px" width="100%" height="10px">
        <path className="path2" style={{strokeDashoffset: getProgressLineStatus(shipment.status)}} fill="blue" strokeWidth="3"
              stroke="red" d="M0 0 l1120 0"/>
      </svg>

      <svg className="placeholder-line" version="1.1" id="line_2"
           x="0px" y="0px" width="100%" height="2px">
        <path fill="blue" strokeWidth="3" stroke="#f2f2f2" d="M0 0 l1120 0"/>
      </svg>

      <Row className="shipment-status">
        <Col>{PickupTypes.RECOGIDA}</Col>
        <Col>{PickupTypes.IN_ORIGIN_WAREHOUSE}
        <b className="text-danger d-block">
          {getCityFromBranch(shipment.pickup_branch as Branch)}
        </b>
        </Col>
        <Col>{PickupTypes.TO_DISPATCH}</Col>
        <Col>{PickupTypes.IN_DESTINATION_WAREHOUSE}
         <b className="text-danger d-block">
           {getCityFromBranch(shipment.delivery_branch as Branch)}
         </b>
        </Col>
        <Col>{PickupTypes.TO_HAULAGE}</Col>
        <Col>{PickupTypes.SHIPMENT_DELIVERED}</Col>
      </Row>

    </div>
  );
};

export default ProgressShipmentComponent;
